import { noop } from 'lodash'

import { isDatasetReady } from '../dataset-controller/rootReducer'

import { syncDynamicRepeatersWithStateFactory } from './syncDynamicRepeatersWithState'
import { syncInputComponentsWithStateFactory } from './syncInputComponentsWithState'
import { syncLinkableComponentsWithStateFactory } from './syncLinkableComponentsWithState'
import { StateSideEffectContext } from './types'


const SYNC_COMPONENTS_WITH_STATE_FACTORIES = [
  syncDynamicRepeatersWithStateFactory,
  syncInputComponentsWithStateFactory,
  syncLinkableComponentsWithStateFactory,
]

const syncComponentsWithState = (context: StateSideEffectContext) => {
  const { subscribe, getState } = context.store

  const subscribers = SYNC_COMPONENTS_WITH_STATE_FACTORIES
    .map(factory => factory(context))
    .filter(subscriber => !!subscriber)

  if (subscribers.length === 0) {
    return noop
  }

  return subscribe(() => {
    if (isDatasetReady(getState())) {
      subscribers.forEach(subscriber => subscriber())
    }
  })
}

export default syncComponentsWithState